import { render } from "./AccountSettings.vue?vue&type=template&id=5f45b3d8&ts=true"
import script from "./AccountSettings.vue?vue&type=script&lang=ts"
export * from "./AccountSettings.vue?vue&type=script&lang=ts"

import "./AccountSettings.vue?vue&type=style&index=0&id=5f45b3d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__